var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer py-30 py-lg-50"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "flex-column-reverse flex-lg-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7"
    }
  }, [_c('p', {
    staticClass: "footer__tit page-text font-weight-bold line-height-1 mb-8 mb-lg-14"
  }, [_vm._v(" 한국전자정보통신산업진흥회 전자제조센터 ")]), _c('p', {
    staticClass: "footer__info mb-12 mb-lg-32"
  }, [_vm._v(" 주소 : 04366 서울특별시 용산구 청파로77 원효전자상가6동 3층 "), _c('br'), _vm._v(" TEL : 070-5088-0218"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "22px"
    }
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-md-none"
  }), _vm._v(" FAX : 070-7500-0095"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "22px"
    }
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-md-none"
  }), _vm._v(" EMAIL : yes@gokea.org "), _c('br'), _vm._v(" 사업자등록번호 : 220-82-00143 ")]), _c('p', {
    staticClass: "footer__copy"
  }, [_vm._v(" Copyright 2021. KOREA ELECTRONICS ASSOCIATION. All rights reserved. ")])]), _c('v-col', {
    staticClass: "d-lg-flex flex-lg-column align-lg-end mb-16 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('ul', {
    staticClass: "footer__link"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("개인정보처리방침")])], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }